import React from "react";
import TextInput from "../../../core/form/TextInput";

let ClientPhoneField = (props) => {

    return <TextInput
        mask='+48 999 999 999'
        name='phone'
        label='form.client.phone'
        {...props}
    />

}

export default ClientPhoneField